/* eslint-disable */
import React from 'react';
import type { City } from '../../../models/common/places';

export const useGooglePlaces = (
  isGoogleMapsApiLoaded: boolean,
  searchTerm: string,
  countryCode?: string,
) => {
  const [places, setPlaces] = React.useState<City[]>([]);
  const autocompleteService = React.useRef<google.maps.places.AutocompleteService>();

  const fetchPlaces = () => {
    if (autocompleteService.current && searchTerm) {
      autocompleteService.current.getPlacePredictions(
        {
          input: searchTerm,
          types: ['(regions)'],
          ...(countryCode && { componentRestrictions: { country: countryCode } }),
        },
        (predictions, status) => {
          setPlaces(parseGooglePredictions(predictions, status));
        },
      );
    }
  };

  React.useEffect(() => {
    if (isGoogleMapsApiLoaded && !autocompleteService.current) {
      autocompleteService.current = new google.maps.places.AutocompleteService();
    }
  }, [isGoogleMapsApiLoaded]);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      fetchPlaces();
    }, 400);
    return () => {
      clearTimeout(timer);
    };
  }, [searchTerm]);

  return places;
};

const parseGooglePredictions = (
  predictions: google.maps.places.AutocompletePrediction[],
  status: google.maps.places.PlacesServiceStatus,
): City[] => {
  if (status !== google.maps.places.PlacesServiceStatus.OK) {
    return [];
  }
  return predictions
    .filter((prediction) => !prediction.types.includes('country') && prediction.terms.length > 0)
    .map((p) => {
      if (p.terms.length > 1) {
        return {
          name: p.terms
            .slice(0, -1)
            .map((t) => t.value)
            .join(', '),
          countryName: p.terms[p.terms.length - 1].value,
          placeId: p.place_id,
        };
      }
      return {
        name: p.terms[0].value,
        placeId: p.place_id,
        countryName: '',
      };
    });
};
